var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"fullscreenIframe",staticClass:"fullscreen-iframe",attrs:{"src":_vm.externalUrl,"allow":"scripts;camera;microphone"},on:{"load":_vm.handleIframeLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }